import { Vertrag } from '@/domain/vertraege/shared/types/vertrag';
import { faCalendar } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18next, { t } from 'i18next';

export function Vertragsvereinbarung({ vertrag }: { vertrag: Vertrag }) {
  const formatFaelligkeitsdatum = Intl.DateTimeFormat(i18next.language).format(
    new Date(vertrag.faelligkeitsdatum),
  );

  return (
    <div className="w-full flex flex-col gap-2">
      <div>{t('domain.vertraege.slide.contractPartTitle')}</div>
      <div className="flex gap-3">
        <div className="size-10 rounded-md p-3 bg-neutrals-200 flex justify-center items-center">
          <FontAwesomeIcon
            className="text-neutrals-800 size-6"
            icon={faCalendar}
          />
        </div>
        <div className="flex flex-col justify-start gap-1">
          <div className="text-sm font-bold">
            {vertrag.vertragIntervall === 'JAHR'
              ? t('domain.vertraege.slide.yearly')
              : t('domain.vertraege.slide.monthly')}
          </div>
          <div className="text-xs">
            {t('domain.vertraege.slide.nextInvoice')}
            {formatFaelligkeitsdatum}
          </div>
        </div>
      </div>
    </div>
  );
}
